import React from 'react';
import classNames from 'classnames';
import Typography, { Variant } from '@lib/components/Typography/Typography';
import Collapse from '@lib/components/Collapse/Collapse';
import styles from './DashboardTitleHeader.module.scss';

type Props = {
  actions?: React.ReactNode;
  bottomSpace?: 'none' | 'small' | 'middle' | 'large';
  children?: React.ReactNode;
  title?: React.ReactNode;
  titleClassName?: string;
  titleVariant?: Variant;
};

export default function DashboardTitleHeader(props: Props) {
  const {
    actions,
    children,
    title,
    titleClassName,
    titleVariant = 'h2',
    bottomSpace = 'large',
  } = props;
  return (
    <div
      className={classNames(styles.header, titleVariant, {
        [styles.withBottomSpaceSmall]: bottomSpace === 'small',
        [styles.withBottomSpaceMiddle]: bottomSpace === 'middle',
        [styles.withBottomSpaceLarge]: bottomSpace === 'large',
      })}
    >
      <div>
        {title && typeof title === 'string' && (
          <Collapse minHeight={120} useCropBlurWhite>
            <Typography
              variant={titleVariant}
              className={classNames(styles.title, titleClassName)}
            >
              {title}
            </Typography>
          </Collapse>
        )}
        {title && typeof title === 'object' && title}
        {children}
      </div>
      {!!actions && <div className={styles.headerActions}>{actions}</div>}
    </div>
  );
}
